// 单文件引入方式

import Deletable from './ZuiDeletable.vue'

export default {
  install(Vue) {
    Vue.component('ZuiDeletable', Deletable)
  }
}
export { Deletable }
